import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import withData from '@bd/bdcore-data';
import { typography, colors } from '../../styles';

const styles = css`
  margin-bottom:40px;
  @media (min-width: 768px) {
    margin-bottom:100px;
  }
  .DetailHeader_wrapper {
    height: calc(100vh - 60px);
    max-height:800px;
    width:100%;
    background-size: cover;
    background-position: center;
    display:flex;
    flex-flow:column wrap;
    justify-content: flex-end;
  }
  h1 {
    color: white;
    font:700 24px/1.2 ${typography.SansSerif};
    padding:20px;
    text-align: center;
    background-size: contain;
    background-position: center;
    background-repeat:no-repeat;
    background:rgba(255,255,255,.7);
    color:${colors.color1};
    margin:0;
    @media (min-width: 768px) {
      font:700 48px/1.2 ${typography.SansSerif};
    }
  }
  h1 span {
    font:400 16px/1.2 ${typography.SansSerif};
    padding:16px;
    display:block;
    text-align: center;
    padding:0;
    @media (min-width: 768px) {
      font:400 20px/1.2 ${typography.SansSerif};
    }
  }
`;

function PlanDetailHeader({ plan }) {
  return (
    <div className={styles}>
      <div className="DetailHeader_wrapper" style={{ backgroundImage: `url('${buildThumbnailUrl(get(plan, 'photos[0].contentUrl'), { width: 1200, height: 1200 })}')` }}>
        <h1>
          {get(plan, 'name')}
        </h1>
      </div>
    </div>
  );
}

PlanDetailHeader.propTypes = {
  plan: PropTypes.object.isRequired,
};

export default withData(
  {
    plan: true,
  },
  {
    required: {
      plan: true,
    },
  },
)(PlanDetailHeader);



// WEBPACK FOOTER //
// ./src/pages/PlanDetail/PlanDetailHeader.js